import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core/react/tracking';

import { useStarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';
import { useQueryParamValue } from 'src/app/shared/hooks/location';

import {
	SUGGESTED_TEMPLATE_NOTICE,
	SUGGESTED_TEMPLATE_NOTICE_CLICK_EVENT,
	SUGGESTED_TEMPLATE_NOTICE_VIEW_EVENT,
} from '../../../../constants';

export type UseSuggestedTemplateNoticeProps = {
	onClick: () => void;
};

export type UseSuggestedTemplateNoticeResult = ModelHookResult<
	undefined,
	{
		trackSuggestedTemplateBannerView: () => void;
		handleClick: () => void;
	}
>;

export function useSuggestedTemplateNotice({
	onClick,
}: UseSuggestedTemplateNoticeProps): UseSuggestedTemplateNoticeResult {
	const {
		data: {
			petition: {
				signatureState: {
					signatureCount: { displayed },
				},
			},
		},
	} = useStarterDashboardV2PageData();
	const track = useTracking();
	const sourceLocation = useQueryParamValue('source_location');

	const trackSuggestedTemplateBannerView = useCallback(() => {
		void track(SUGGESTED_TEMPLATE_NOTICE_VIEW_EVENT, {
			source_location: sourceLocation,
			signature_count: displayed,
		});
	}, [track, sourceLocation, displayed]);

	const handleClick = useCallback(() => {
		void track(SUGGESTED_TEMPLATE_NOTICE_CLICK_EVENT, {
			petition_update_template: SUGGESTED_TEMPLATE_NOTICE,
			source_location: sourceLocation,
		});
		onClick();
	}, [track, sourceLocation, onClick]);

	return {
		actions: {
			trackSuggestedTemplateBannerView,
			handleClick,
		},
	};
}
